import React from "react";
import { Container } from "reactstrap";
import { CSSTransition } from 'react-transition-group';
import useIsInViewport from "ui/hooks/inViewport";
import PricingMainImage from "assets/img/homepage/employer/pricing-main.jpg";

const MainPricingImg = () => {

    const[inView1, getPricingImg1] = useIsInViewport();


        return(
            <React.Fragment>
                <Container className="text-center">
                    <CSSTransition in={inView1} timeout={200} classNames="more_details_img"><img ref={getPricingImg1} src={PricingMainImage} className="w-100 more_details_img" alt="Get Matched"></img></CSSTransition>
                </Container>
            </React.Fragment>
        )

}

export default MainPricingImg;